import React from 'react';
import { Box } from '../element';
import { ShowContent } from '../../components/showContent';

export const WizardStepDescription = ({ step = 1, steps }) => {
  if (!steps || (Array.isArray(steps) && steps.length === 0)) return null;

  const currentStep = steps[step - 1] || steps[0];
  return (
    <Box direction="column" className="paddingTop4 paddingBottom4">
      {/* <Text
        id="title"
        className="fontSize24 semiBold lineHeightCompact paddingBottom4"
      >
        {currentStep.title}
      </Text> */}
      <Box direction="column" className="markdownContent">
        <ShowContent contentString={currentStep} />
        {/* {currentStep.content.map((item, index) => (
          <Text
            id="content"
            key={`stepDesc${index}`}
            className="fontSize18 paddingBottom4"
          >
                <Markdown>{currentStep}</Markdown>
            {' '}
            {item}{' '}
          </Text>
        ))} */}
      </Box>
    </Box>
  );
};
